import React, {useState} from 'react'
import {Col, Input, Row} from "reactstrap";

// components
import {CustomIconButton} from "../buttons/buttonsActions";

// labels
import {SELECT_SCHEDULE} from "../i18n/i18n";

const SelectSchedules = props => {
    const {setExternalValue} = props

    const [hour, setHour] = useState('')

    const onAddHour = () => {
        if(!hour || hour === '')
            return

        setHour('')
        setExternalValue(hour)
    }

    return <>
        <h3>{SELECT_SCHEDULE}</h3>

        <Row className="">
            <Col sm={'4'} className={'offset-sm-3'}>
                <Input
                    type="time"
                    name="hourStart"
                    value={ hour }
                    onChange={ e => setHour(e.target.value) }
                    placeholder="Ingrese hora"
                    style={ {float:'right'} }
                />
            </Col>
            <Col sm={'2'}>
                <CustomIconButton icon='fa fa-plus' clazz='icon-btn-add' onClick={onAddHour}/>
            </Col>
        </Row>
    </>

}

export default SelectSchedules